export interface OpenWindowOptions {
  errorMessage?: string;
  free?: boolean;
  onError?(): void;
}

export const openWindow = (
  url?: string,
  target?: string,
  features?: string,
  _replace?: boolean,
  options?: OpenWindowOptions,
) => {
  const { errorMessage = '', free = false, onError = () => undefined } = options || {};

  try {
    const popout = typeof window !== 'undefined' && window.open(url, target, features);
    if (free && popout) {
      popout.opener = null;
    }
    return popout;
  } catch (error: unknown) {
    onError();
    if (typeof window !== 'undefined' && errorMessage) {
      // TODO use a toast
      window.alert(errorMessage);
    }

    return null;
  }
};
